module.exports = __webpack_public_path__ + "img/163.8891f137.jpg";